














import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';
import { IFormControl } from '@/entities/form.interface';
import { IListItem, MeModel } from '@/entities';
import companiesApi from '@/api/companies.api';
import store from '@/store/store';
import * as types from '@/store/types';
import { AccountRole } from '@/entities/accounts/account-role.enum';

@Component({})
export default class OfficeSelect extends Vue {
    @Prop() public control: IFormControl;

    // @Prop() public disabled: boolean = false;
    @Prop({ default: false }) public disabled: boolean;

    public loading: boolean;

    public companies: IListItem[] = [];

    @Emit()
    public change($event) {
        // emit value to parent
    }

    public created() {
        this._loadCompanies();
    }

    private async _loadCompanies() {
        const hasAdminPermissions =
            store.getters[types.AUTH_HAS_ADMIN_PERMISSIONS];
        const me: MeModel = store.getters[types.AUTH_GET_ROLE];
        this.loading = true;
        try {
            if (hasAdminPermissions) {
                const items = await companiesApi.list(false);
                const mapped = items.map((x) => {
                    return { value: x.id, heading: x.officeName };
                });
                this.companies = [{ heading: 'All', value: null }, ...mapped];
            } else {
                this.companies = [
                    { heading: me.officeName, value: me.companyId }
                ];
                this.control.value = me.companyId;
            }
        } finally {
            this.loading = false;
        }
    }
}
